// extracted by mini-css-extract-plugin
module.exports = {"container":"FormsOverviewHeader_container__ioiWg","header":"FormsOverviewHeader_header__SaDGK","subHeader":"FormsOverviewHeader_subHeader__N7dxh"};